var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.client)?_c('games-general-settings',{attrs:{"games-settings":_vm.client.settings.gamesSettings,"save-games-settings":function (settings) { _vm.save(settings); }}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/vue-loader/lib??vue-loader-options!./src/components/clients/client/games/general.vue?vue&type=template&id=066545c9
// module id = MYYo
// module chunks = 0